<template>
  <div class="site-footer critical-component-clear">
    <div class="site-footer__container grid no-row-gap">
      <div class="site-footer__container-left col xs4 l2-6">
        <div class="site-footer__navigation">
          <div
            v-for="(tier1) of navigation.footer"
            :key="`footer-column-${tier1.handle}`"
            class="site-footer__navigation-column"
          >
            <ul
              class="site-footer__navigation-list"
              :class="{ [$class('active')]: activeColumn === tier1.handle }"
            >
              <li class="site-footer__navigation-header">
                <button
                  class="
                    site-footer__navigation-link
                    site-footer__navigation-title
                  "
                  :tabindex="isMobile ? 0 : -1"
                  type="button"
                  @click="handleTitleClick(tier1.handle)"
                >
                  <span v-text="tier1.title" />
                  <icon-cross />
                  <icon-plus />
                </button>
              </li>

              <transition-height>
                <div
                  v-show="!isMobile || activeColumn === tier1.handle"
                  class="site-footer__navigation-list-items"
                >
                  <li
                    v-for="(tier2) of tier1.links"
                    :key="`footer-link-${tier2.handle}`"
                    class="site-footer__navigation-item"
                  >
                    <a
                      class="site-footer__navigation-link text-body-s"
                      :href="tier2.url"
                      :target="tier1.handle === 'social' ? '_blank' : '_self'"
                      @click="(evt) => handlePotentialCookiesClick(tier2.url, evt)"
                      v-text="tier2.title"
                    />
                  </li>
                </div>
              </transition-height>
            </ul>
          </div>
        </div>
      </div>

      <div class="site-footer__container-right col xs4 l8-11">
        <div
          v-if="liquid.settings.newsletter_enable"
          class="site-footer__newsletter"
        >
          <div
            class="site-footer__newsletter-heading text-heading-l"
            v-text="$string('general.site_footer.newsletter_heading')"
          />

          <div
            class="site-footer__newsletter-description"
            v-html="$string('general.site_footer.newsletter_description_html')"
          />

          <div class="site-footer__newsletter-form text-body-xs">
            <slot name="newsletter" />
          </div>

          <div
            class="site-footer__newsletter-caption"
            v-html="$string('general.site_footer.newsletter_caption_html')"
          />
        </div>
      </div>
    </div>

    <div class="site-footer__additional grid">
      <div class="site-footer__legal col xs2 l2-6 grid">
        <p
          class="
            site-footer__copyright
            text-body-s
            col
            xs2
            l1
          "
          v-text="$string('general.site_footer.copyright', {
            replace: { year: new Date().getFullYear() }
          })"
        />

        <p
          class="
            site-footer__tagline
            text-body-s
            col
            xs2
            l4
          "
          v-text="$string('general.site_footer.tagline')"
        />
      </div>
    </div>
  </div>
</template>

<script>

/**
 * Vue: Site footer
 * -----------------------------------------------------------------------------
 * Site footer component with accordion display of links.
 *
 */
import { mapActions, mapState } from 'vuex'

import TransitionHeight from '~async/transition-height/transition-height'

import IconCross from '~icons/misc/cross.svg'
import IconPlus from '~icons/misc/plus.svg'

export default {
  name: 'SiteFooter',

  components: {
    IconCross,
    IconPlus,
    TransitionHeight,
  },

  props: {
    liquid: {
      type: Object,
      default: () => ({
        sectionId: '',
        settings: '',
        locale: '',
      }),
    },
    navigation: {
      type: Object,
      default: () => ({
        footer: [],
      }),
    },
  },

  data() {
    return {
      activeColumn: '',
    }
  },

  computed: {

    /**
     * Map Vuex state.
     */
    ...mapState({
      isMobile: (state) => state.index.screen.mobile,
    }),
  },

  methods: {

    /**
     * Map Vuex actions.
     */
    ...mapActions({
      toggleOverlay: 'overlays/toggle',
    }),

    /**
     * Handle accordion/column click.
     * @param {String} handle - Tier 1 link handle.
     */
    handleTitleClick(handle) {
      this.activeColumn = this.activeColumn === handle ? '' : handle
    },

    handlePotentialCookiesClick(url, evt) {
      if (url.includes('#cookies')) {
        evt.preventDefault()
        evt.stopPropagation()
        window.Pandectes.fn.showBanner()
      }
    },
  },
}
</script>

<style lang="scss">
@import './site-footer';
</style>
